import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSegmentData = "/engagement/segment_data";
export const engagementSegmentDataCacheKeys: AllRouteEndpoints[] = [engagementSegmentData];
